import ComponentBasePrototype from 'ComponentBasePrototype';
import RequestUtils from '../../../base/request/request';
import $ from 'jquery';

export default class Tablist extends ComponentBasePrototype {
  build() {
    this.tablistLabelSelector = '.cms-tablist__label';
    this.listSelector = '.cms-tablist__navbar';
    this.scrollLeftButtonSelector = '.cms-tablist__scroll-left-button';
    this.scrollRightButtonSelector = '.cms-tablist__scroll-right-button';
    this.tablistLabelActiveClass = 'cms-tablist__label--active';
    this.list = this.node.find(this.listSelector);
    this.setHandlers();
    this.initializeScrollArrows();
    return true;
  }

  setHandlers() {
    const tabButtons = this.node.find(this.tablistLabelSelector);

    tabButtons.on('click', (event) => {
      this.setActiveTab(event.target);

      const anchor = $(event.target).attr('id');
      this.appendAnchorUrlParameter(anchor);

      // Find the corresponding tab panel and set its aria-labelledby attribute
      const tabPanelId = `cms-tablist-panel-${anchor}`;
      const tabPanel = document.getElementById(tabPanelId);
      if (tabPanel) {
        tabPanel.setAttribute('aria-labelledby', anchor);
      }
    });

    tabButtons.on('keydown', (event) => {
      const currentTab = $(event.target);
      let newTab;
      const currentIndex = tabButtons.index(currentTab);
      switch (event.key) {
        case 'ArrowLeft':
          newTab = tabButtons.eq(currentIndex - 1);
          if (newTab.length === 0) {
            newTab = tabButtons.last();
          }
          break;
        case 'ArrowRight':
          newTab = tabButtons.eq(currentIndex + 1);
          if (newTab.length === 0) {
            newTab = tabButtons.first();
          }
          break;
        default:
          return;
      }
      if (newTab.length > 0) {
        newTab.focus();
        this.setActiveTab(newTab[0]);
        const anchor = newTab.attr('id');
        this.appendAnchorUrlParameter(anchor);
      }
      event.preventDefault();
    });

    this.list.on('scroll', () => {
      this.initializeScrollArrows();
    });

    this.node.on('click', this.scrollLeftButtonSelector, () => {
      this.triggerScrollLeft();
    });

    this.node.on('click', this.scrollRightButtonSelector, () => {
      this.triggerScrollRight();
    });

    $(window).on('resize', () => {
      this.initializeScrollArrows();
    });

    $(window).on('popstate', () => {
      const anchor = RequestUtils.getQueryParam('anchor');
      let activeTab = this.node.find(`.cms-tablist__label#${anchor}`);
      if (activeTab.length === 0) {
        activeTab = this.node.find('.cms-tablist__label')[0];
      }
      this.setActiveTab(activeTab);
    });
  }

  appendAnchorUrlParameter(anchor) {
    if (anchor) {
      if (history.pushState) {
        history.pushState(null, null, `?anchor=${anchor}`);
      } else {
        // Legacy support, will cause page reload
        document.location.href = document.location.href.contains('?')
          ? `${document.location.href}&anchor=${anchor}`
          : `${document.location.href}?anchor=${anchor}`;
      }
    } else {
      const newUrl = document.location.href.replace(/[&?]anchor=[a-zA-Z0-9_-]*/, '');

      if (history.pushState) {
        history.pushState(null, null, newUrl);
      } else {
        // Legacy support, will cause page reload
        document.location.href = newUrl;
      }
    }
  }

  setActiveTab(target) {
    this.removeAllActiveClasses();
    this.addActiveClassToTab(target);
    this.activateSelectedRadioButton(target);
  }

  activateSelectedRadioButton(target) {
    const radioButtonId = $(target).attr('aria-controls').replace('cms-tablist-panel-', 'cms-tablist-radio-');
    const radioButton = this.node.find(`#${radioButtonId}`);
    radioButton.prop('checked', true).trigger('click');
  }

  addActiveClassToTab(target) {
    $(target).addClass(this.tablistLabelActiveClass);
    $(target).attr('aria-selected', 'true');
  }

  removeAllActiveClasses() {
    const tabButtons = this.node.find(this.tablistLabelSelector);
    tabButtons.removeClass(this.tablistLabelActiveClass);
    tabButtons.attr('aria-selected', 'false');
  }

  initializeScrollArrows() {
    const parentElement = this.list.parent();
    // Position left arrow to be visible if the element position is more than 5 px from
    // the left edge
    if (this.list[0].scrollLeft > 5) {
      parentElement.addClass('scrollLeft');
    } else {
      parentElement.removeClass('scrollLeft');
    }

    if (this.list[0].scrollLeft < this.list[0].scrollWidth - this.list[0].offsetWidth - 5) {
      parentElement.addClass('scrollRight');
    } else {
      parentElement.removeClass('scrollRight');
    }
  }

  triggerScrollLeft() {
    this.list.animate({ scrollLeft: this.list[0].scrollLeft - this.list[0].clientWidth }, 400, () => {
      this.updateAriaHidden();
    });
  }

  triggerScrollRight() {
    this.list.animate({ scrollLeft: this.list[0].scrollLeft + this.list[0].clientWidth }, 400, () => {
      this.updateAriaHidden();
    });
  }

  updateAriaHidden() {
    const navbarContainer = this.node.find('.cms-tablist__navbar-container');

    const scrollLeftButton = this.node.find(this.scrollLeftButtonSelector);
    const scrollRightButton = this.node.find(this.scrollRightButtonSelector);

    if (navbarContainer.length) {
      const hasScrollLeft = navbarContainer.hasClass('scrollLeft');
      const hasScrollRight = navbarContainer.hasClass('scrollRight');
      if (scrollLeftButton.length) {
        scrollLeftButton.attr('aria-hidden', !hasScrollLeft);
      }
      if (scrollRightButton.length) {
        scrollRightButton.attr('aria-hidden', !hasScrollRight);
      }
    }
  }
}